import * as _ from 'lodash';
import {createSelector} from 'reselect';
import {getYearData} from '../year';
import {IYear} from '../../../data/data';
import {getCarbonOutputPercentage} from '../outputs/carbonOutput';
import {getEnergyOutputRatio} from '../outputs/energyOutput';
import {countPowerSourcesByType} from '../powerSources';
import {PowerSourceCounts} from '../savedPowerSourceCounts';
import {getDeprecate} from "../power-sources/deprecate";
import {getDamage} from "../power-sources/damage";


/**
 * test the player's current game settings against the year's targets
 */
export const isYearAlreadyComplete = createSelector(

    [getYearData, countPowerSourcesByType, getCarbonOutputPercentage, getEnergyOutputRatio],

    (year_data: IYear, sources_by_type: PowerSourceCounts, carbon_output_percentage: number, energy_output_ratio: number) =>
    {
        const {outage, 'mini-game': mini_game, demand, 'carbon-target': carbon_target, remove} = year_data;

        console.group('isYearAlreadyComplete');
        console.log('year_data', year_data);
        console.log('sources_by_type', sources_by_type);
        console.log('carbon_output_percentage', carbon_output_percentage);
        console.log('energy_output_ratio', energy_output_ratio);
        console.log('remove', remove);
        console.groupEnd();

        if (outage || mini_game) return false;

        if (remove)
        {
            //  test whether the player currently has any of the given type of power sources
            //TODO  should the minimum here be 1?

            console.log('removed all targets', sources_by_type[remove]);

            return sources_by_type[remove] <= 1;
        }

        console.log('meeting demand', _.inRange(energy_output_ratio, 0.4, 0.6));
        console.log('meeting carbon target', carbon_output_percentage, carbon_target, carbon_output_percentage >= carbon_target * 10);

        return carbon_output_percentage >= carbon_target * 10 && _.inRange(energy_output_ratio, 0.45, 0.55);
    }
);


/**
 * test the player's current game settings against the year's targets
 */
export const isYearComplete = createSelector(

    [getYearData, countPowerSourcesByType, getCarbonOutputPercentage, getEnergyOutputRatio],

    (year_data: IYear, sources_by_type: PowerSourceCounts, carbon_output_percentage: number, energy_output_ratio: number) =>
    {
        const {outage, 'mini-game': mini_game, demand, 'carbon-target': carbon_target, remove} = year_data;

        console.group('isYearComplete');
        console.log('year_data', year_data);
        console.log('sources_by_type', sources_by_type);
        console.log('carbon_output_percentage', carbon_output_percentage);
        console.log('energy_output_ratio', energy_output_ratio);
        console.log('remove', remove);
        console.groupEnd();

        if (outage || mini_game) return false;

        if (remove)
        {
            //  test whether the player currently has any of the given type of power sources
            //TODO  should the minimum here be 1?

            console.log('removed all targets', sources_by_type[remove]);

            return sources_by_type[remove] <= 1;
        }

        console.log('meeting demand', _.inRange(energy_output_ratio, 0.4, 0.6));
        console.log('meeting carbon target', carbon_output_percentage, carbon_target, carbon_output_percentage >= carbon_target * 10);

        const {ignore = {}} = year_data;

        return (ignore.carbon === true || carbon_output_percentage >= carbon_target * 10) && (ignore.energy === true || _.inRange(energy_output_ratio, 0.45, 0.55));
    }
);


export const allDamagedStationsRepaired = createSelector(

    [getYearData, getDeprecate, getDamage],

    (year: IYear, deprecated: boolean[], damage: boolean[]) : boolean =>
    {
        if (! year.deprecate && ! year.outage) return false;

        // console.group('allDamagedStationsRepaired');
        // console.log('deprecate_id', deprecate_id);
        // console.groupEnd();

        return _.compact(deprecated).length === 0 && _.compact(damage).length === 0;
    }
);



// WEBPACK FOOTER //
// ./src/ts/store/reducers/calendar/isYearAlreadyComplete.ts